import { DesktopDatePicker, DesktopDatePickerProps } from '@mui/x-date-pickers';
import React from 'react';
import { ControllerRenderProps } from 'react-hook-form';
import { EditProjectFormData } from '../edit-project.store';

interface DateInputProps {
  field: ControllerRenderProps<EditProjectFormData, 'completed_at'>;
}

const DateInput: React.FC<DateInputProps> = ({ field }) => {
  return (
    <DesktopDatePicker
      {...field}
      label="Completion date"
      slotProps={slotProps}
      displayWeekNumber
    />
  );
};

const slotProps: DesktopDatePickerProps['slotProps'] = {
  field: { clearable: true },
  textField: { size: 'small' },
};

export default DateInput;
